import { render, staticRenderFns } from "./siderRightTextOptions.vue?vue&type=template&id=5d8989b8&scoped=true&"
import script from "./siderRightTextOptions.vue?vue&type=script&lang=js&"
export * from "./siderRightTextOptions.vue?vue&type=script&lang=js&"
import style0 from "./siderRightTextOptions.vue?vue&type=style&index=0&id=5d8989b8&lang=scss&scoped=true&"
import style1 from "./siderRightTextOptions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8989b8",
  null
  
)

export default component.exports